import get from 'lodash/get';
import {
  CIRCLES,
  CIRCLE_FAMILY,
  CANCEL_INVITATION,
} from '../../constants/strings';
import { CARE_ROLE } from '../../constants/props';

export const removeFromCircleOption = (action, params, formatMessage) => ({
  text: formatMessage(CIRCLES.actionTitles.removeFromCircle),
  onClick: () => action(params),
  icon: 'log-out',
});

export const assignCaregiverOption = (action, familyMember, formatMessage) => ({
  text: formatMessage(CIRCLES.assignCaregiver),
  onClick: () => action(familyMember),
  icon: 'heart',
});

export const removeCaregiverOption = (action, params, formatMessage) => ({
  text: formatMessage(CIRCLES.removeCaregiver),
  onClick: () => action(params),
  icon: 'remove',
});

export const cancelCaregiverInvitation = (action, params, formatMessage) => ({
  text: formatMessage(CANCEL_INVITATION),
  onClick: () => action(params),
  icon: 'heart',
});

export const assignRoleToDependentOption = (
  action,
  familyMember,
  formatMessage,
) => ({
  text: formatMessage({ id: 'circles.actions.assignRole' }),
  onClick: () => action(familyMember),
  icon: 'heart',
});

export const removeGuardianOption = (
  action,
  params,
  formatMessage,
  isLastGuardian,
) => ({
  text: formatMessage(CIRCLES.removeGuardian),
  onClick: () => action(params, isLastGuardian),
  icon: 'remove',
});

export default ({
  formatMessage,
  isLoggedUser,
  isCaregiver,
  isVerifiedDependent,
  loggedUserId,
  item,
  type,
  removeFromCircle,
  openCancelCaregiverInvitePopup,
  removeCaregiverRole,
  targetUserId,
  removeGuardianRole,
  openLeaveCirclePopup,
  isLastGuardian,
  onOpenSimpleFormPopup,
}) => {
  const menu = [];
  const caregiver = get(item, [CARE_ROLE.CAREGIVER], false);
  const isGuardian =
    get(item, [CARE_ROLE.GUARDIAN], false) ||
    get(item, [CARE_ROLE.PROXY], false) ||
    get(item, [CARE_ROLE.PARENT], false);

  const hasGlobalPermissions = isLoggedUser || isVerifiedDependent;
  const hasPermissions = hasGlobalPermissions || isCaregiver;

  // user can remove anyone except himself
  const canRemoveFromCircle =
    (hasGlobalPermissions || (isCaregiver && !isGuardian)) &&
    loggedUserId !== item.id;

  // user can remove caregiver role if role is assigned
  const canRemoveCaregiver = hasPermissions && caregiver;

  // user can cancel caregiver invitation if invitation is sent
  const canCancelCaregiverInvitation = hasPermissions && item.pendingCaregiver;

  // logged user can assign caregiver role if role wasn't assign previously
  const isFamilyCircle = type === CIRCLE_FAMILY;
  const caregiverIsNotAssigned = !caregiver && !item.pendingCaregiver;

  const canAssignCaregiver =
    isLoggedUser && isFamilyCircle && caregiverIsNotAssigned;

  const canRemoveGuardianRole = isVerifiedDependent && isGuardian;

  // can assign role to dependent
  if (isVerifiedDependent) {
    menu.push(
      assignRoleToDependentOption(onOpenSimpleFormPopup, item, formatMessage),
    );
  }

  if (canRemoveFromCircle) {
    const params = { userId: targetUserId, memberId: item.id };

    menu.push(removeFromCircleOption(removeFromCircle, params, formatMessage));
  }

  if (canAssignCaregiver) {
    menu.push(
      assignCaregiverOption(onOpenSimpleFormPopup, item, formatMessage),
    );
  }

  if (canRemoveCaregiver) {
    const params = { userId: targetUserId, memberId: item.id };

    menu.push(
      removeCaregiverOption(removeCaregiverRole, params, formatMessage),
    );
  }

  if (canCancelCaregiverInvitation) {
    menu.push(
      cancelCaregiverInvitation(
        openCancelCaregiverInvitePopup,
        item,
        formatMessage,
      ),
    );
  }

  if (canRemoveGuardianRole) {
    const action = isLastGuardian ? openLeaveCirclePopup : removeGuardianRole;
    const params = { userId: targetUserId, memberId: item.id };
    menu.push(
      removeGuardianOption(action, params, formatMessage, isLastGuardian),
    );
  }

  return menu;
};



// WEBPACK FOOTER //
// ./src/utils/circles/getMenu.js